import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=09ec7666&scoped=true&lang=pug"
import script from "./addCase.vue?vue&type=script&lang=js"
export * from "./addCase.vue?vue&type=script&lang=js"
import style0 from "./addCase.vue?vue&type=style&index=0&id=09ec7666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec7666",
  null
  
)

export default component.exports